<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">{{ !loading ? (isEditMode ? "Edit" : "Create") : "" }} Department</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/ptpdepartment">Back to PTP Departments</a>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-body">
                <form nz-form [formGroup]="form" class="form-horizontal">
                    <div class="form-group">
                        <label for="departmentName" class="col-md-2 control-label">
                            Name<span style="color: red"> *</span>
                        </label>
                        <div class="col-md-6">
                            <input
                                id="departmentName"
                                type="text"
                                maxlength="100"
                                class="form-control"
                                formControlName="departmentName" />
                            @if (form.get("departmentName")?.touched && form.get("departmentName")?.invalid) {
                                <span class="text-danger"> Name is required </span>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <button nz-button nzType="primary" (click)="save()">Save Changes</button>
    </div>
</div>
